import { Component, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorHandlerService } from '@aveva/connect-web-core';
import { Status } from 'src/app/enums/status.model';
import { Student } from 'src/app/models/student.model';
import { StudentsService } from 'src/app/services/students.service';
import { AccountSelectorInputAsyncComponent } from '../../accounts/account-selector-input-async/account-selector-input-async.component';
import * as globals from '../../globals';
import { LoggingService } from '../../../services/logging.service';

@Component({
  standalone: false,
  selector: 'app-add-student',
  templateUrl: './add-student.component.html',
  styleUrls: ['./add-student.component.scss']
})

export class AddStudentComponent {

  constructor(
    private errorHandler: ErrorHandlerService,
    private studentsService: StudentsService,
    private snackBar: MatSnackBar,
    private logger: LoggingService) { }

  @HostListener('window:beforeunload')
  canDeactivate(): boolean {
    return !this.form.dirty || this.form.submitted;
  }

  create() {
    this.loadingSpinner.emit(true);

    if (this.submitting) {
      this.loadingSpinner.emit(false);
      return;
    }

    if(String(this.accountSelectedId) === '0') {
      this.displaySnackBar(globals.select_account);
      this.loadingSpinner.emit(false);
      return;
    }

    this.submitting = true;

    const student: Student = {
      class_id: this.class_id,
      account_id: String(this.accountSelectedId),
      first_name: (this.student.first_name === undefined || this.student.first_name === '') ? this.student.email_id.trim() : this.student.first_name.trim(),
      last_name: this.student.last_name === undefined ? '' : this.student.last_name.trim(),
      email_id: this.student.email_id.trim(),
      folder_name: this.student.folder_name.trim(),
      group_name: this.student.group_name.trim(),
      status: Status.Unassigned
    };

    try {      
      this.studentsService.create_student(student).subscribe({
        next: (data) => {
          this.logger.logEvent('Student Create Success', { accountId: this.accountSelectedId, email: student.email_id});
          this.form.resetForm();
          this.loadingSpinner.emit(false);
          this.displaySnackBar(globals.studentCreate_success);
          this.saved.emit(data);
          this.accountCleared();
        },
        error: (e) => {
          this.logger.logException(e);
          this.loadingSpinner.emit(false);
          this.displaySnackBar(globals.studentCreate_fail);
        }
      });

    } catch (error) {
      this.logger.logException(error);
      if (error.error?.statusCode === 400 && error.error?.errorCode === globals.RESOURCELIMIT) {
        this.errorHandler.handle(error.error, 'studentLimitReached');
      } else {
        return this.errorHandler.handle(error);
      }
    }
    finally {
      this.submitting = false;
    }
  }

  cancel() {
    this.form.resetForm();
    this.cancelled.emit();
    this.accountSelectorInputAsyncComponent.clear();
  }

  close() {
    this.cancelled.emit();
    this.accountSelectorInputAsyncComponent.clear();
  }

  loadingSpinnerEmit = (value: boolean) => this.loadingSpinner.emit(value);

  accountChanged = (accountId: number) => this.accountSelectedId = accountId;

  accountCleared = () => this.accountSelectorInputAsyncComponent.clear();

  displaySnackBar = (message: string) => this.snackBar.open(message, null, {duration: 5000});

  student: Student = {} as Student;
  submitting = false;
  accountSelectedId = 0;

  @Input() class_id = 0;
  @ViewChild('form', { static: true }) form: NgForm;
  @ViewChild(AccountSelectorInputAsyncComponent, { static: false }) accountSelectorInputAsyncComponent: AccountSelectorInputAsyncComponent;
  @Output() saved: EventEmitter<any> = new EventEmitter();
  @Output() cancelled: EventEmitter<any> = new EventEmitter();
  @Output() loadingSpinner: EventEmitter<boolean> = new EventEmitter();

}
